/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Arable_Gopher_ClipInputs */

const fr_witty_arable_gopher_clip = /** @type {(inputs: Witty_Arable_Gopher_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton 1RM théorique est`)
};

/**

* @param {Witty_Arable_Gopher_ClipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_arable_gopher_clip = /** @type {((inputs?: Witty_Arable_Gopher_ClipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Arable_Gopher_ClipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_arable_gopher_clip(inputs)
});